
import Vip from '../views/Vip/main.vue'
import IosRule from '../views/Vip/IosRule.vue'
import IosSignRule from '../views/Vip/IosSignRule.vue'
import VipForWx from '../views/Vip/VipForWx.vue'
import VipForIos from '../views/Vip/VipForIos.vue'
import Ysf from '../views/Ysf.vue'
import SuperPaper from '../views/SuperPaper.vue'
import DownloadApp from '../views/DownloadApp.vue'
import FreeDivision from '../views/FreeDivision.vue'
import FreeRadio from '../views/FreeRadio.vue'
import Diversion from '../views/Diversion'
import Present from '../views/Present'
import BookDetail from '../views/Present/components/bookDetail'
import Recharge from '../views/Recharge/Index.vue'
import PaySuccess from '../views/paySuccess.vue'
import WxService from '../views/wx-service.vue'
import MediaCourse from '../views/MediaCourse'
import MediaCourseDetail from '../views/MediaCourse/MediaCourseDetail'
/* router-import-placeholder */

export default [
  // 在404里做处理
  // {
  //   path: '/',
  //   redirect: {
  //     name: 'recommend'
  //   }
  // },
  /* router-config-placeholder */
  {
    path: '/wx-service',
    name: 'wx-service',
    component: WxService
  },
  {
    path: '/media-course',
    name: 'media-course',
    component: MediaCourse
  },
  {
    path: '/media-course-detail',
    name: 'media-course-detail',
    component: MediaCourseDetail
  },
  {
    path: '/pay-success',
    name: 'pay-success',
    component: PaySuccess
  },
  {
    path: '/recharge',
    name: 'recharge',
    component: Recharge,
    meta: {
      title: '才博充值'
    }
  },
  {
    path: '/diversion',
    name: 'Diversion',
    component: Diversion
  },
  {
    path: '/present',
    name: 'present',
    component: Present
  },
  {
    path: '/bookDetail',
    name: 'bookDetail',
    component: BookDetail
  },
  {
    path: '/free-radio/:courseId',
    name: 'free-radio',
    component: FreeRadio
  },
  {
    path: '/free-division',
    name: 'free-division',
    meta: {
      title: '免费专区'
    },
    component: FreeDivision
  },
  {
    path: '/download-app',
    name: 'download-app',
    component: DownloadApp
  },
  {
    path: '/super-paper',
    name: 'super-paper',
    meta: {
      title: '才博'
    },
    component: SuperPaper
  },
  {
    path: '/exchange',
    name: 'exchange-router',
    component: () => import('../views/Exchange/Router.vue'),
    redirect: {
      name: 'exchange-index'
    },
    meta: {
      title: '我的兑换'
    },
    children: [
      {
        path: 'index',
        name: 'exchange-index',
        meta: {
          title: '兑换奖励'
        },
        component: () => import('../views/Exchange/Exchange.vue')
      },
      {
        path: 'list',
        name: 'exchange-list',
        meta: {
          title: '兑换记录'
        },
        component: () => import('../views/Exchange/ExchangeList.vue')
      },
      {
        path: 'rule',
        name: 'exchange-rule',
        meta: {
          title: '兑换记录'
        },
        component: () => import('../views/Exchange/ExchangeRule.vue')
      },
    ]
  },
  {
    path: '/vip-for-ios',
    name: 'vip-for-ios',
    component: VipForIos
  },
  {
    path: '/vip-for-wx',
    name: 'vip-for-wx',
    component: VipForWx
  },
  {
    path: '/ysf',
    name: 'ysf',
    component: Ysf
  },

  {
    path: '/vip-activity',
    name: 'vip-activity',
    meta: {
      title: '畅学卡'
    },
    component: () => import('../views/Vip/VipForWps.vue')
  },
  {
    path: '/ios-sign-rule',
    name: 'ios-sign-rule',
    meta: {
      title: '会员使用协议'
    },
    component: IosSignRule
  },
  {
    path: '/ios-rule',
    name: 'ios-rule',
    meta: {
      title: '才博服务协议'
    },
    component: IosRule
  },
  {
    path: '/vipRules',
    name: 'vip-rule',
    meta: {
      title: '续费协议'
    },
    component: () => import('../views/Vip/rule.vue')
  },
  {
    path: '/vip',
    name: 'vip',
    meta: {
      title: '畅学卡'
    },
    component: Vip
  },
  {
    path: '/protocol',
    name: 'protocol',
    meta: {
      title: '才博隐私协议'
    },
    component: () => import('../views/Protocol.vue')
  },
  {
    path: '/activity/cmcc',
    name: 'cmcc',
    component: () => import('../views/Activity/Cmcc.vue')
  },
  {
    path: '/wps-template',
    name: 'wps-template',
    component: () => import('../views/WpsTemplate/Router.vue'),
    redirect: {
      name: 'wps-template-list'
    },
    meta: {
      title: '我的模板'
    },
    children: [
      {
        path: 'list',
        name: 'wps-template-list',
        meta: {
          title: '我的模板'
        },
        component: () => import('../views/WpsTemplate/List.vue')
      },
      {
        path: 'detail',
        name: 'wps-template-detail',
        component: () => import('../views/WpsTemplate/Detail.vue')
      }
    ]
  },
  {
    path: '/user-conversion',
    name: 'conversion',
    component: () => import('../views/Conversion.vue')
  },
  {
    path: '/custom-time',
    name: 'custom-time',
    component: () => import('../views/CustomTime.vue')
  },
  {
    path: '/activity/pullnew',
    name: 'activity-pullnew',
    component: () => import('../views/Activity/PullNew.vue')
  },
  {
    path: '/preferential',
    name: 'preferential',
    component: () => import('../views/Preferential.vue')
  },
  {
    path: '/article',
    name: 'article',
    meta: {
      title: '早读'
    },
    component: () => import('../views/Article.vue')
  },
  {
    path: '/group-result',
    name: 'group-result',
    component: () => import('../views/GroupResult')
  },
  {
    path: '/knowledge-show',
    name: 'knowledge-show',
    component: () => import('../views/KnowledgeShow')
  },
  {
    path: '/poster',
    name: 'poster',
    meta: {
      title: '海报制作'
    },
    component: () => import('../views/Poster.vue')
  },
  {
    path: '/comment4video',
    name: 'comment4video',
    meta: {
      title: '留言'
    },
    component: () => import('../views/Comment4video.vue')
  },
  {
    path: '/privilege',
    name: 'privilege',
    meta: {
      title: '畅学卡'
    },
    component: () => import('../views/Privilege.vue')
  },
  {
    path: '*',
    name: '404',
    meta: {
      title: '页面未找到'
    },
    component: () => import('../views/404.vue')
  },
  {
    path: '/live',
    name: 'live',
    component: () => import('../views/Live'),
    meta: {
      title: '直播'
    }
  },
  {
    path: '/money',
    name: 'money',
    meta: {
      title: '奖励金'
    },
    component: () => import('../views/Money.vue')
  },
  {
    path: '/money_strategy',
    name: 'money-strategy',
    meta: {
      title: '奖励金攻略'
    },
    component: () => import('../views/MoneyStrategy.vue')
  },
  {
    path: '/gift',
    name: 'gift',
    meta: {
      title: '礼物'
    },
    component: () => import('../views/Gift.vue')
  },
  {
    path: '/video-detail',
    name: 'video-detail',
    meta: {
      title: '课程详情',
      Intercept: true
    },
    component: () => import('../views/VideoDetail.vue')
  },
  {
    path: '/share',
    name: 'share',
    meta: {
      title: '分享'
    },
    component: () => import('../views/Share.vue')
  },
  {
    path: '/sign-up-result-ok2',
    name: 'sign-up-result-ok2',
    meta: {
      title: '支付结果'
    },
    component: () => import('../views/SignUpResult.vue')
  },
  {
    path: '/today',
    name: 'today',
    meta: {
      title: '已购课程'
    },
    component: () => import('../views/Today.vue')
  },
  {
    path: '/recommend',
    name: 'recommend',
    meta: {
      title: '发现好课'
    },
    // 实现下拉加载把js文件换成了vue文件
    component: () => import('../views/Recommend/index.vue')
  },
  {
    path: '/mine',
    name: 'mine',
    redirect: {
      name: 'mine-page'
    },
    component: () => import('../views/MineRouter.vue'),
    children: [
      {
        path: 'main',
        name: 'mine-page',
        meta: {
          title: '个人中心'
        },
        component: () => import('../views/Mine.vue')
      },
      {
        path: 'course',
        name: 'mine-course',
        component: () => import('../views/MineCourse.vue')
      },
      {
        path: 'coupon',
        name: 'mine-coupon',
        meta: {
          title: '代金券'
        },
        component: () => import('../views/MineCoupon.vue')
      },
      {
        path: 'account',
        name: 'mine-account',
        meta: {
          title: '奖励金'
        },
        component: () => import('../views/MineAccount.vue')
      },
      {
        path: 'gift',
        name: 'mine-gift',
        component: () => import('../views/MineGift.vue')
      },
      {
        path: 'help',
        name: 'mine-help',
        meta: {
          title: '帮助与反馈'
        },
        component: () => import('../views/MineHelp.vue')
      }
    ]
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('../views/Feedback.vue')
  },
  {
    path: '/list/:id?/:type?',
    name: 'list',
    meta: {
      title: '精彩分类'
    },
    component: () => import('../views/List')
  },
  {
    path: '/sign-up',
    name: 'sign-up',
    meta: {
      title: '课程报名'
    },
    component: () => import('../views/SignUp/Index.vue')
  },
  {
    path: '/group',
    name: 'group',
    meta: {
      title: '拼团'
    },
    component: () => import('../views/Group.vue')
  },
  {
    path: '/schedule',
    name: 'schedule',
    meta: {
      title: '课程表'
    },
    component: () => import('../views/Schedule.vue')
  },
  {
    path: '/free_video',
    name: 'free_video',
    meta: {
      title: '免费视频'
    },
    component: () => import('../views/FreeVideoRouter.vue'),
    children: [
      {
        path: 'main/:courseId',
        name: 'free_video_main',
        meta: {
          title: '免费视频'
        },
        component: () => import('../views/FreeVideo.vue')
      },
      {
        path: 'search',
        meta: {
          title: '免费视频'
        },
        component: () => import('../views/FreeVideoSearch.vue')
      }
    ]
  },
  {
    path: '/audio-detail',
    name: 'audio-detail',
    meta: {
      title: '课程详情'
    },
    component: () => import('../views/AudioDetail.vue')
  },
  {
    path: '/wealth',
    name: 'wealth',
    meta: {
      title: '我的钱包'
    },
    component: () => import('../views/WealthRouter.vue'),
    children: [
      {
        path: 'main',
        name: 'wealth-main',
        meta: {
          title: '我的钱包'
        },
        component: () => import('../views/Wealth.vue')
      },
      {
        path: 'detail',
        name: 'wealth-detail',
        meta: {
          title: '我的钱包'
        },
        component: () => import('../views/WealthDetail.vue')
      },
      {
        path: 'rule',
        name: 'wealth-rule',
        meta: {
          title: '我的钱包'
        },
        component: () => import('../views/WealthRule.vue')
      }
    ]
  },
  {
    path: '/pay',
    name: 'pay',
    meta: {
      title: '支付'
    },
    component: () => import('../views/Pay.vue')
  },
  {
    path: '/rich-text',
    name: 'rich-text',
    meta: {
      title: '精品推荐'
    },
    component: () => import('../views/RichText.vue')
  },
  {
    path: '/get-read',
    name: 'get-read',
    meta: {
      title: '早读订阅'
    },
    component: () => import('../views/GetRead.vue')
  },
  {
    path: '/authentication',
    name: 'authentication',
    meta: {
      title: '身份认证'
    },
    component: () => import('../views/Authentication.vue')
  },
  {
    path: '/clock-schedule',
    name: 'clock-schedule',
    meta: {
      title: '打卡'
    },
    component: () => import('../views/ClockSchedule.vue')
  },
  {
    path: '/show-image',
    name: 'show-image',
    meta: {
      title: '展示图片'
    },
    component: () => import('../views/ShowImage.vue')
  },
  {
    path: '/sign-up-result-for-promote',
    name: 'sign-up-result-for-promote',
    meta: {
      title: '训练营购买成功'
    },
    component: () => import('../views/SignUpResultForPromote.vue')
  },
  {
    path: '/withdraw',
    name: 'withdraw',
    meta: {
      title: '提现'
    },
    component: () => import('../views/Withdraw.vue')
  },
  {
    path: '/address',
    name: 'address',
    meta: {
      title: '地址输入'
    },
    component: () => import('../views/Address.vue')
  }
]
